import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  
  // Check if this is an admin route
  const isAdminRoute = req.url.includes('/admin/');
  
  // Use admin token for admin routes and memorial routes (so admins can access private memorials)
  // Regular token for other routes
  const isMemorialRoute = req.url.includes('/memorials/') || req.url.includes('/m/');
  const adminToken = storage.getAdminToken();
  const regularToken = storage.getToken();
  
  // Prefer admin token if available for admin routes or memorial routes
  const token = isAdminRoute || (isMemorialRoute && adminToken) 
    ? (adminToken || regularToken)
    : regularToken;

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req);
};
